import { render, staticRenderFns } from "./EmptyNotification.vue?vue&type=template&id=4e2cb91d&scoped=true"
import script from "./EmptyNotification.vue?vue&type=script&lang=js"
export * from "./EmptyNotification.vue?vue&type=script&lang=js"
import style0 from "./EmptyNotification.vue?vue&type=style&index=0&id=4e2cb91d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cb91d",
  null
  
)

export default component.exports